import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    margin: theme.spacing(-2, 0, 7.51, 0),
  },
  description: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.labraText.primary,
  },
  content: {
    marginTop: theme.spacing(2),
  },
  horizontalDivider: {
    borderTop: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: theme.spacing(0.5),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: '100%',
  },
  renewalInfo: {
    display: 'flex',
    height: '48px',
    background: '#FFDAD6',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.25px',
    padding: theme.spacing(1.5, 5, 1.5, 5),
    margin: theme.spacing(-4, -4, 2, -4),
  },
  contractRed: {
    color: theme.palette.error.dark,
  },
  contractOrange: {
    color: '#CE8040',
  },
}))
